import { Avatar as MuiAvatar, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { initialsOf } from '../model';

type AssigneeAvatarProps = {
    /** Assignee display name; undefined renders the empty "Unassigned" slot. */
    name: string | undefined;
};

/**
 * 18px assignee avatar with initials, square per the app-wide MuiAvatar
 * radius. Unassigned renders as an empty dash-bordered slot (MuiAvatar's
 * person-icon fallback is suppressed).
 */
export default function AssigneeAvatar({ name }: AssigneeAvatarProps) {
    const intl = useIntl();
    return (
        <Tooltip
            title={name ?? intl.formatMessage({ id: 'patientList.unassigned' })}
            placement="left"
        >
            <MuiAvatar
                sx={{
                    width: 18,
                    height: 18,
                    bgcolor: name ? 'background.raised' : 'transparent',
                    border: 1,
                    borderColor: 'divider',
                    borderStyle: name ? 'solid' : 'dashed',
                    fontFamily: 'fontFamilyMonospace',
                    fontSize: 9,
                    color: 'text.secondary',
                    '& .MuiAvatar-fallback': { display: 'none' },
                }}
            >
                {name ? initialsOf(name) : undefined}
            </MuiAvatar>
        </Tooltip>
    );
}
